import { OperatorFunction } from 'rxjs';
import { filter } from 'rxjs/operators';

export function filterNil<T>(): OperatorFunction<T | null | undefined, T> {
  return (input$) =>
    input$.pipe(filter((x): x is T => x !== null && x !== undefined));
}
